import { Badge, Container, Paper, Stack, Text, Title } from '@mantine/core';
import { ImgConverter } from '@/components/ImgConverter';
import { SeoContent } from '@/components/SeoContent';
import { AdSlot } from '@/components/AdSlot';
import { useStrings } from '@/i18n/useLang';

export function HomePage() {
  const t = useStrings();

  return (
    <Container size="md" py="xl">
      <Stack gap="md" align="center" mb="xl" ta="center">
        <Badge variant="light" color="cyan" size="lg">
          {t.hero.localBadge}
        </Badge>
        <Title order={1} style={{ fontSize: 'clamp(1.8rem, 5vw, 2.8rem)' }}>
          {t.hero.title}
        </Title>
        <Text size="lg" c="dimmed" maw={640}>
          {t.hero.subtitle}
        </Text>
      </Stack>

      <Paper
        withBorder
        radius="lg"
        p={{ base: 'md', sm: 'xl' }}
        mt="lg"
        style={{ background: 'var(--bg-card)', borderColor: 'var(--border)' }}
      >
        <ImgConverter />
      </Paper>

      <AdSlot slot={import.meta.env.VITE_ADSENSE_SLOT_CONTENT} />

      <SeoContent />
    </Container>
  );
}
